<template>
    <div class="el-main-wrapper">
        <el-row class="el-title-block">
            <h1 class="el-title-with-icon">
                {{ $t('navigation.waitingAreaTool') }}
                <span v-if="selectedContainer"
                    >: {{ selectedContainer.Description }}</span
                >
            </h1>
        </el-row>
        <el-row>
            <stc-wa-notification-list></stc-wa-notification-list>
        </el-row>
        <stc-dialog
            :title="title"
            v-model="toggleCreateEditView"
            @change="closeDialog"
        >
            <div class="el-main-content">
                <stc-wa-notification-create
                    v-if="toggleCreateEditView"
                    :isEditable="isEditable"
                    :data="waNotification"
                    :waitingAreas="waitingAreas"
                ></stc-wa-notification-create>
            </div>
        </stc-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import WANotificationList from '../../components/waiting-area-tool/WaitingAreaList'
import WANotificationCreate from '../../components/waiting-area-tool/BookingCreate'
import StcDialog from '../../components/Dialog'
import WaitingAreaMixin from '../../mixins/waiting-areas-mixin'

export default {
    name: 'waiting-area-tool',

    components: {
        'stc-wa-notification-list': WANotificationList,
        'stc-wa-notification-create': WANotificationCreate,
        'stc-dialog': StcDialog,
    },

    computed: mapGetters(['selectedContainer']),

    mixins: [WaitingAreaMixin],

    data() {
        return {
            title: '',
            toggleCreateEditView: false,
            isEditable: false,
            waNotification: {},
            waitingAreas: [],
        }
    },

    created() {
        this.fetchWaitingAreas()

        Events.$on('update-wanotification-title', (val) => {
            if (val) {
                this.title =
                    this.$t('form.title.create') +
                    ' ' +
                    this.$t('form.title.booking')
            } else {
                this.title =
                    this.$t('form.title.update') +
                    ' ' +
                    this.$t('form.title.booking')
            }
        })

        Events.$on(
            'toggle-wanotification-create-view',
            (val, waNotifiaction) => {
                if (waNotifiaction && waNotifiaction.WANotificationID) {
                    this.isEditable = true
                    this.waNotification = waNotifiaction
                } else {
                    this.isEditable = false
                    this.waNotification = undefined
                }
                this.toggleCreateEditView = val
                Events.$emit('close-tippy')
            }
        )

        Events.$on('upload-files-success', (response) => {
            if (response) {
                // Adding 1 second delay for backend to process files. Imediate listing fetch doesn't include new files.
                setTimeout(() => {
                    Events.$emit('date-range-changed')
                    this.toggleCreateEditView = false
                    Events.$emit('close-tippy')
                }, 1000)
            }
        })
    },

    beforeDestroy() {
        Events.$off('update-wanotification-title')
        Events.$off('toggle-wanotification-create-view')
        Events.$off('upload-files-success')
    },

    methods: {
        closeDialog() {
            this.toggleCreateEditView = false
            Events.$emit('close-tippy')
        },
    },
}
</script>
